import { UiState, UiStateEnum } from "./UiState";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { math, Wall } from "@rhinov/savane-js";

export class CutAndRulerState extends UiState {

    _currentWallDimension: Wall;
    wallsSelected: Wall | null = null;
    cursorPositionWithoutSnap = math.vec3.create();

    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3, wall: Wall) {
        super(cursorPosition, cocosPosition);
        this._currentWallDimension = wall;
        if (cursorPosition !== undefined) {
            math.vec3.copy(this.cursorPositionWithoutSnap, cursorPosition);
            this.setSelected();
        }


        if (this.horizontalRuler) {
            GameObjectManager.createRuler(false);
        } else {
            GameObjectManager.deleteRuler(false);
        }

        if (this.verticalRuler) {
            GameObjectManager.createRuler(true);
        } else {
            GameObjectManager.deleteRuler(true);
        }
        GameObjectManager.drawRuler(this.cursorPosition);
    }

    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;
        this.cursorPositionWithoutSnap = math.vec3.clone(cursorPosition);
        this.setSelected();
        if (this.getNextUiState() === this.getUiState()) {
            if (this.wallsSelected !== null && this.hoverEntities.length === 1 && this.hoverEntities[0].isWallEntity()) {
                if (this._currentWallDimension.id === this.hoverEntities[0].id) {
                    GameObjectManager.drawCutDimension(this.cursorPosition, this._currentWallDimension, this.cursorPositionWithoutSnap);
                } else {
                    GameObjectManager.deleteCutDimension();
                    this._currentWallDimension = this.hoverEntities[0] as Wall;
                    GameObjectManager.drawCutDimension(this.cursorPosition, this._currentWallDimension, this.cursorPositionWithoutSnap);
                }
            }

            if (this.horizontalRuler && !GameObjectManager.rulerCreated(false)) {
                GameObjectManager.createRuler(false);
            } else if (!this.horizontalRuler && GameObjectManager.rulerCreated(false)) {
                GameObjectManager.deleteRuler(false);
            }

            if (this.verticalRuler && !GameObjectManager.rulerCreated(true)) {
                GameObjectManager.createRuler(true);
            } else if (!this.verticalRuler && GameObjectManager.rulerCreated(true)) {
                GameObjectManager.deleteRuler(true);
            }

            GameObjectManager.drawRuler(this.cursorPosition);
            return null;
        }
        else {
            GameObjectManager.deleteCutDimension();
            GameObjectManager.deleteRuler(false);
            GameObjectManager.deleteRuler(true);
            return this.createNextUiState();
        }
    }

    getUiState(): number {
        return UiStateEnum.uiCutAndRulerState;
    }
}